import { Box, Typography } from "@mui/material";
import { getVppKeyForSite } from "actions/vpp";
import { Modal } from "components";
import { VppKey } from "empower-energy-owner-components";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const VppKeyModal = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const details = useSelector((state) => state.unit?.details);
  const loading = useSelector((state) => state.vpp?.loading);
  const vppKey = useSelector((state) => state.vpp?.vppKey);

  useEffect(() => {
    if (details?.site?.id) {
      dispatch(getVppKeyForSite(details?.site?.id));
    }
  }, [dispatch, details]);

  return (
    <Modal
      title="VPP Connection Key"
      open={open}
      onClose={onClose}
      width="500px"
    >
      <Box>
        <Typography variant="body2" fontWeight={500} mb={2}>
          To join this battery to a supported Virtual Power Plant (VPP), you may
          use this unique VPP key to identify this battery.
        </Typography>

        <VppKey
          loading={loading}
          vppKey={vppKey}
          onCopy={() => toast.info("VPP Key copied!")}
        />
      </Box>
    </Modal>
  );
};

export default VppKeyModal;
